if (!customElements.get('product-hotspots')) {
  class ProductHotspots extends HTMLElement {
    constructor() {
      super();
      this.active = null;
      this.onDocumentClick = (event) => {
        if (!this.contains(event.target)) this.close();
      };
      this.addEventListener('click', (event) => this.onClick(event));
      this.addEventListener('keyup', (event) => {
        if (event.key === 'Escape') this.close();
      });
    }

    connectedCallback() {
      document.addEventListener('click', this.onDocumentClick);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
    }

    onClick(event) {
      const trigger = event.target.closest('.phs-trigger');
      if (trigger) {
        const wasOpen = trigger === this.active;
        this.close();
        if (!wasOpen) this.open(trigger);
        return;
      }
      if (event.target.closest('.phs-tooltip')) return;
      this.close();
      if (this.hasAttribute('data-picker')) this.pick(event);
    }

    open(trigger) {
      const tooltip = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!tooltip) return;
      tooltip.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      this.active = trigger;
      this.keepInside(tooltip);
    }

    close() {
      if (!this.active) return;
      const tooltip = document.getElementById(this.active.getAttribute('aria-controls'));
      if (tooltip) {
        tooltip.hidden = true;
        tooltip.style.removeProperty('--phs-shift');
      }
      this.active.setAttribute('aria-expanded', 'false');
      this.active = null;
    }

    // Shift the tooltip sideways when it would stick out of the image
    keepInside(tooltip) {
      const gap = 8;
      const bounds = this.getBoundingClientRect();
      const rect = tooltip.getBoundingClientRect();
      let shift = 0;
      if (rect.left < bounds.left + gap) shift = bounds.left + gap - rect.left;
      if (rect.right > bounds.right - gap) shift = bounds.right - gap - rect.right;
      tooltip.style.setProperty('--phs-shift', `${shift}px`);
    }

    // Theme editor only: click the image to read the X/Y position
    pick(event) {
      const bounds = this.getBoundingClientRect();
      const x = Math.round(((event.clientX - bounds.left) / bounds.width) * 100);
      const y = Math.round(((event.clientY - bounds.top) / bounds.height) * 100);
      if (!this.picker) {
        this.picker = document.createElement('span');
        this.picker.className = 'phs-picker';
        this.append(this.picker);
      }
      this.picker.style.left = `${x}%`;
      this.picker.style.top = `${y}%`;
      this.picker.dataset.coords = `X ${x} · Y ${y}`;
    }
  }

  customElements.define('product-hotspots', ProductHotspots);
}
